import * as Yup from 'yup';

const serviceProductSchema = Yup.object().shape({
  labelEn: Yup.string().required('English Label is required.'),
  labelAr: Yup.string().required('Arabic Label is required.'),
  vendorId: Yup.string().required('Vendor is required.'),
  categoryId: Yup.string().required('Category is required.'),
  basePrice: Yup.number().min(0).typeError('Must be Number'),
  maxQty: Yup.number().min(1).typeError('Must be Number'),
  orderAvailabilityGapDays: Yup.number().min(0).typeError('Must be Number'),
});

export default serviceProductSchema;
